/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureDiskSettings } from '../models/AzureDiskSettings';

export class AzureDisk {
  /**
  * Cloud-provider-assigned disk ID.
  */
  'providerDiskId': string;
  'settings': AzureDiskSettings;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "providerDiskId",
      "baseName": "providerDiskId",
      "type": "string",
      "format": ""
    },
    {
      "name": "settings",
      "baseName": "settings",
      "type": "AzureDiskSettings",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureDisk.attributeTypeMap;
  }

  public constructor() {
  }
}

